import axiosInstance from './axiosInstance';

const normalizeList = (data, key) => {
  if (Array.isArray(data)) return data;
  if (data && Array.isArray(data[key])) return data[key];
  if (data && Array.isArray(data.data)) return data.data;
  return [];
};

const mapStaffFromApi = (s) => {
  if (!s) return null;
  const status = s.status ?? (s.is_active === 1 || s.is_active === true ? 'active' : 'inactive');
  return {
    id: s.id,
    name: s.name ?? '',
    employeeId: s.employee_id ?? s.employeeId ?? '',
    phone: s.phone ?? '',
    email: s.email ?? '',
    designation: s.designation ?? s.position ?? '',
    position: s.designation ?? s.position ?? '',
    status: typeof status === 'string' ? status.toLowerCase() : status,
    createdAt: s.created_at,
    updatedAt: s.updated_at,
  };
};

const buildStaffPayload = (data) => ({
  name: data.name?.trim() || undefined,
  employee_id: data.employeeId?.trim() || data.employee_id?.trim() || undefined,
  phone: data.phone?.trim() || undefined,
  email: data.email?.trim() || undefined,
  designation: data.designation?.trim() || data.position?.trim() || undefined,
});

export const fetchStaff = async () => {
  const response = await axiosInstance.get('/staff');
  const list = normalizeList(response.data, 'staff') || normalizeList(response.data, 'data') || (Array.isArray(response.data) ? response.data : []);
  return list.map(mapStaffFromApi).filter(Boolean);
};

export const fetchStaffById = async (id) => {
  const response = await axiosInstance.get(`/staff/${id}`);
  const raw = response.data?.staff ?? response.data?.data ?? response.data;
  return mapStaffFromApi(raw);
};

export const createStaff = async (data) => {
  const payload = buildStaffPayload(data);
  const response = await axiosInstance.post('/staff', payload);
  const created = response.data?.staff ?? response.data?.data ?? response.data;
  return mapStaffFromApi(created);
};

export const updateStaff = async (id, data) => {
  const payload = buildStaffPayload(data);
  const response = await axiosInstance.put(`/staff/${id}`, payload);
  const updated = response.data?.staff ?? response.data?.data ?? response.data;
  return mapStaffFromApi(updated);
};

export const deleteStaff = async (id) => {
  await axiosInstance.delete(`/staff/${id}`);
};

export const toggleStaffStatus = async (id) => {
  const response = await axiosInstance.patch(`/staff/${id}/toggle-status`);
  const updated = response.data?.staff ?? response.data?.data ?? response.data;
  return mapStaffFromApi(updated);
};
